import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { GUI } from "./GUI";
import { HUD } from "./hud/HUD";
import { PauseLayer } from "./PauseLayer";
import { BoardContainer } from "./BoardContainer";
import { BoardManager } from "./BoardManager";
import { Orb } from "./orbs/Orb";
import { GameOverLayer } from "./GameOverLayer";
import ICandyScene from "../ICandyScene";
import { GameManager } from "../../GameManager";
import { ErrorLayer } from "../ErrorLayer";
declare var gamezop: any;
declare var oMetaManager: any;
export class BoardScene extends Phaser.Scene implements ICandyScene {

    public static currentInstance: BoardScene;

    public boardManager: BoardManager;

    private hud: HUD;
    private gui: GUI;
    private boardContainer: BoardContainer;
    private pauseLayer: PauseLayer;
    private errorLayer: ErrorLayer;
    private gameOverLayer: any;
    private inactivityTimer: any;
    private intervalTimer: any;
    private t: any;

    constructor() {

        super("BoardScene");

        BoardScene.currentInstance = this;
    }

    public create(): void {
        GameManager.setCurrentScene(this);

        this.boardManager = new BoardManager(this);
        // console.log(GameVars.candyEngine.board);

        const background = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "background");
        background.setScale(3);

        this.boardContainer = new BoardContainer(this);
        this.add.existing(this.boardContainer);

        this.hud = new HUD(this);
        this.add.existing(this.hud);

        this.gui = new GUI(this);
        this.add.existing(this.gui);

        this.input.on("pointerdown", this.onPointerDown, this);

        AudioManager.playSound("soundtrack", true, .5);

        this.setInactivityTimer();
    }

    public update(): void {

        this.boardContainer.update();
        this.hud.update();

        if (!GameVars.orbsMoving && !GameVars.levelingUp && !GameVars.paused && !GameVars.gameOver && this.input.activePointer.isDown) {

            const p1 = this.boardManager.p1;
            const p2 = this.boardManager.p2;

            if (p1 && p2 === null) {

                const p2 = this.getOrbPosition();

                if (p2 && !(p1.c === p2.c && p1.r === p2.r)) {
                    this.boardManager.onOrbSelected(p2);
                }
            }
        }

    }

    public pause(): void {

        this.pauseLayer = new PauseLayer(this);
        this.add.existing(this.pauseLayer);
    }

    public resume(): void {

        this.pauseLayer.destroy();
    }

    public onClickClaim(): void {

        this.gameOverLayer.onClickClaim();
    }

    public onDuelResultLoaded(data: any): void {

        this.gameOverLayer.onResultLoaded(data);
    }

    public showErrorLayer(data: any, func: any): void {

        this.errorLayer = new ErrorLayer(this, data.type, data.value, func);
        this.add.existing(this.errorLayer);
    }

    public onLevelUp(firstInstantiation?: boolean, newCol?: boolean): void {

        this.hud.onLevelUp();
        GameVars.isLevelUp += 1;

        gamezop.setState({
            score: GameVars.isLevelUp,
            fps: Math.floor(GameVars.currentScene.game.loop.actualFps),
            state: "levelup",
            tcount: GameVars.tc,
            kcount: GameVars.kc,
            metadata: oMetaManager.meta
        });

        this.time.delayedCall(350, function (): void {
            this.boardContainer.onLevelUp(false, newCol);
        }, [], this);
    }

    public updateMoves(): void {

        this.hud.updateMoves();
    }

    public updateScore(orbsEliminated: number, rematchesCounter: number): void {

        this.hud.updateScore(orbsEliminated, rematchesCounter);
    }

    public onNoRematch(orbsEliminated: number): void {
        this.hud.updateScore(orbsEliminated);
        this.setInactivityTimer();
    }

    public onLeaderBoardAssetsLoaded(): void {

        if (this.gameOverLayer) {
            this.gameOverLayer.onLeaderBoardAssetsLoaded();
        }
    }

    public onGameOver(): void {
        clearInterval(this.intervalTimer);
        clearInterval(this.inactivityTimer);

        this.hud.onGameOver();

        this.gameOverLayer = new GameOverLayer(this);
        this.add.existing(this.gameOverLayer);

        AudioManager.stopLoop();
        AudioManager.playSound("gameover", false, .75);
        this.time.delayedCall(1000, function (): void {
            AudioManager.playSound("gameover_loop", true);
        }, [], this);
    }

    public reshuffle(prevBoard: Candy.OrbData[][]): void {

        this.hud.onReshuffle();
        this.boardContainer.reshuffle(prevBoard);
    }

    private onPointerDown(): void {

        this.disableInactivityTimer();

        // this.setInactivityTimer();


        if (GameVars.paused || GameVars.orbsMoving || GameVars.levelingUp || GameVars.gameOver) {
            return;
        }

        GameVars.tc += 1;

        const p = this.getOrbPosition();

        if (p) {
            this.boardManager.onOrbSelected(p);
        }
    }

    private getOrbPosition(): { c: number, r: number } {

        const x = (this.input.activePointer.x - this.boardContainer.x) / this.boardContainer.scaleX + Orb.SIZE / 2;
        const y = (this.input.activePointer.y - this.boardContainer.y) / this.boardContainer.scaleY + Orb.SIZE / 2;

        const c = Math.floor(x / Orb.SIZE);
        const r = Math.floor(y / Orb.SIZE);

        const cols = GameVars.cols;
        const rows = GameVars.rows;

        if (c >= 0 && c < cols && r >= 0 && r < rows) {
            return { c: c, r: r };
        } else {
            return null;
        }
    }

    public setInactivityTimer(timer: number = 30000) {
        if (!gamezop.isBattleGame()) return;
        this.inactivityTimer = setTimeout(() => {
            gamezop.broadcastWinner({ eventName: "inactivity", time: 5 })
            this.inactivityTimer = setTimeout(() => {
                this.onGameOver()
            }, 5000);
        }, timer);
    }

    public disableInactivityTimer() {
        if (!gamezop.isBattleGame()) return;
        gamezop.broadcastWinner({ eventName: "activity" });
        if (this.inactivityTimer) {
            clearTimeout(this.inactivityTimer)
        }
    }
}
